import { Button, Card } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { QuestionCircleTwoTone } from "@ant-design/icons";
import BinLocationService from "../../../services/Wash-service/BinLocationService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import "../../../styles/global-ui.css"; // ✅ same style

const OutWardWashConfirm = ({ userdata }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [binId, setBinId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const bin_id = queryParams.get("binId");

    setBinId(bin_id || "");

    if (!bin_id) {
      ResponseMessage.error("No Bin ID provided.");
    }
  }, [location.search]);

 const handleConfirm = async () => {
  if (!binId) {
    ResponseMessage.error("No Bin ID available.");
    return;
  }

  if (!userdata?.su_id) {
    ResponseMessage.error("User ID not available.");
    return;
  }

  try {
    setLoading(true);

    const response = await BinLocationService.BinOutwardWash(
      binId,
      userdata.su_id
    );

    if (response?.status === false) {
      ResponseMessage.error(response.message || "Failed to confirm outward.");
      return;
    }

    ResponseMessage.success(
      response?.message || "Bin outward confirmed successfully."
    );

    // ✅ navigation fix
    if (window.history.length > 1) {
      navigate(-1);
    } else {
       navigate(-1);
    }

  } catch (error) {
    console.error("Error in handleConfirm:", error);
    ResponseMessage.error(error.message || "An error occurred.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="page-container">
      <Card
        className="modern-card"
        title={
          <div className="page-title">
            <QuestionCircleTwoTone /> Confirm Outward
          </div>
        }
        style={{ maxWidth: 500, margin: "40px auto" }}
      >
        <p style={{ fontSize: "16px", color: "#334155" }}>
          Are you sure you want to confirm the outward of Bin{" "}
          <strong>{binId}</strong> ?
        </p>

        <Button
          type="primary"
          onClick={handleConfirm}
          loading={loading}
          disabled={loading}
          block
          style={{ marginTop: 20 }}
        >
          {loading ? "Confirming..." : "Confirm Outward"}
        </Button>
      </Card>
    </div>
  );
};

export default OutWardWashConfirm;